import React, {Component} from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import {getQueryParamValue} from "../../Constants/getQueryParamValue";
import DocsIndex from "../../App/Docs/DocsIndex"

class APIDocsIndex extends Component {
    componentDidMount(){
        if (localStorage.getItem("email") !== null) {
            let docsMenuItem = getQueryParamValue("docsMenuItem", window.location.href)
            this.props.navigateTo("/api?menuItem=docs&docsMenuItem=" + docsMenuItem)
        }
    }

    render() {
        return (
            <div>
                <DocsIndex page="api"/>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({

})

const mapActionsToProps = {
     navigateTo: push
}

export default connect(mapStateToProps, mapActionsToProps)(APIDocsIndex)